// Description: This is the main component of the application
// Updated: 31/07/2025
// Author: 

// React
import React, { useState, useEffect } from "react";

// Material UI Components
import { ThemeProvider } from "@mui/material/styles";
import { CircularProgress } from "@mui/material";

// Components and functions for the project
import Sidebar from "./components/Sidebar/Sidebar.js";
import MainContent from "./components/layouts/MainContent";
import RoutesApp from "./routes";
import { BrowserRouter } from "react-router-dom";
import AppTheme from "./shared-theme/AppTheme";
import { Toaster } from "react-hot-toast";
import axios from 'axios';
import MobileNavbar from "./components/Mobile/MobileNavbar";
import use123zapStore from "./context/123zapStore";
import { checkAuth } from "./utils/utils";

import SideMenu from './components/sidebar2/SideMenu';

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {

      const location = window.location.pathname;

      if (location !== '/login' && location !== '/') {
        localStorage.removeItem('idToken');
        window.location.href = '/logout';
      }

    }
    return Promise.reject(error);
  }
);

// Layout of the application
const AppLayout = ({ children }) => {

  const userAuthenticated = use123zapStore((state) => state.userAuthenticated);

  return (
    <>
      {userAuthenticated ? (
        <div style={{ display: 'flex' }}>
          <MobileNavbar />
          <SideMenu />
          <MainContent>{children}</MainContent>
        </div>
      ) : (
        <>{children}</>
      )}
    </>
  );
};

// Render the App
function App() {

  const setUserAuthenticated = use123zapStore((state) => state.setUserAuthenticated);
  const initUserInfo = use123zapStore((state) => state.initUserInfo);
  const loadPlanoAtual = use123zapStore((state) => state.loadPlanoAtual);
  const loadUserAvatar = use123zapStore((state) => state.loadUserAvatar);
  const [loadingAuthentication, setLoadingAuthentication] = useState(true);

  useEffect(() => {
    setUserAuthenticated(checkAuth());
  }, []);

  useEffect(() => {
    initUserInfo();
  }, []);

  useEffect(() => {
    loadPlanoAtual();
  }, []);

  useEffect(() => {
    loadUserAvatar();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setLoadingAuthentication(false);
    }, 1000);
  }, []);

  if (loadingAuthentication) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <CircularProgress style={{ color: "rgb(52, 152, 219)" }} />
      </div>
    );
  }

  return (
    <AppTheme>
      <Toaster
        reverseOrder
        toastOptions={{
          position: "bottom-left",
          style: {
            maxWidth: "100vw",
          },
          duration: 5000,
        }}
      />
      <BrowserRouter>
        <AppLayout>
          <RoutesApp />
        </AppLayout>
      </BrowserRouter>
    </AppTheme>
  );
}

export default App;